import { captureMessage } from "@sentry/nextjs";

export const reportError = (label: string, reason: unknown) => {
    if (process.env.NODE_ENV === "development") {
        console.error(label, reason);
    } else {
        captureMessage(`${label}: ${JSON.stringify(reason)}`);
    }
};
